import React from 'react';
import { MobileListItemWithChildren } from './components/MobileListItemWithChildren';
import { MobileMenuListWrapper } from './components/MobileMenuListWrapper';
import { hasProperty } from '@helpers/objectHelpers';
import { ColumnsListItem } from '@layouts/MegaMenu/MegaMenu.types';

interface MegaMenuListMobileProps {
  container: string;
  level: number;
  name: string;
  columnList: ColumnsListItem[] | ColumnsListItem[][];
  i18n: Record<string, string>;
}

export const MegaMenuListMobile = ({
  container,
  level,
  name,
  columnList = [],
  i18n,
}: MegaMenuListMobileProps) => {
  let count = 0;

  const renderMenuItem = (item: ColumnsListItem, index: number, backID: string) => {
    const hasSubCategory = hasProperty(item, 'NoSubCategory') && !item.NoSubCategory;

    count++;

    if (!hasSubCategory) {
      const link = item.UrlSegment || ('HeaderPage' in item && item.HeaderPage) || '';

      return (
        <li
          key={index}
          id={count.toString()}
          className='l-header-mobile-menu-item link iftest'
          onClick={() => window.location.replace(link)}
          data-mobile-menus-id={count}
        >
          <a href={link}>{('Name' in item && item.Name) || item.Title || ''}</a>
        </li>
      );
    }

    return (
      <MobileListItemWithChildren
        key={index}
        count={count}
        item={item}
        level={level}
        backID={backID}
        container={container}
      />
    );
  };

  return (
    <div id={`mobile-mm-${container}-level${level}`} data-mobile-level-section={container}>
      {level == 1 ? (
        <MobileMenuListWrapper
          id={`mobile-mm-${container}-${level}-1`}
          name={name}
          level={level}
          backBtnText={i18n.Back}
        >
          {(columnList as ColumnsListItem[]).map((item: ColumnsListItem, index: number) =>
            renderMenuItem(item, index, `mobile-mm-${container}-${level}-1`)
          )}
        </MobileMenuListWrapper>
      ) : (
        (columnList as ColumnsListItem[][]).map((list, index) => {
          const id = `mobile-mm-${container}-${level}-${index + 1}`;
          return (
            <MobileMenuListWrapper
              key={id}
              id={id}
              name={name}
              level={level}
              backBtnText={i18n.Back}
            >
              {list?.map((item, index) => renderMenuItem(item, index, id))}
            </MobileMenuListWrapper>
          );
        })
      )}
    </div>
  );
};
